export default "__VITE_ASSET__78fe92ac__"